/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function () {

	jQuery('.accordion p:empty, .orbit p:empty').remove();
	jQuery('.alm-paging-content').addClass('grid-x');

	
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	jQuery('.csSlider').slick({
		infinite: true,
		dots: false,
		arrows: true,
		fade: true
	});
	var sticky = new Waypoint.Sticky({
		element: jQuery('.stickyNav')[0]
	});  
	jQuery(".top-bar-right .menu-item").mouseover(function( event ){
		event.preventDefault();
		$('.blueScreen').stop().fadeIn();
	});
	
	$('.submenu').hide();
	jQuery(".top-bar-right .is-dropdown-submenu-parent").mouseover(function( event ){
		event.preventDefault();
		$('.submenu').stop();
		$(this).children('.submenu').fadeIn();
	});

	jQuery(".top-bar-right .menu-item").mouseleave(function( event ){
		event.preventDefault();
		$('.blueScreen').stop().fadeOut();
		$(this).children('.submenu').hide();
		$(this).removeClass('is-active');
	});
	jQuery(".searchBtn").click(function(){
		$(".searchMenu").toggle();
	});

	jQuery(".openMenu").click(function(){
		$(".mobileMenu").fadeToggle();
		$(".mobileMenu").css("display", "flex");
	});

	// jQuery("#mapsvg").click(function(){
	// 	$(".mobileMenu").fadeToggle();
	// });

	// $("#mapsvg").click(function() {
	// 	var offset = 20; //Offset of 20px
	
	// 	$('html, body').animate({
	// 		scrollTop: $(this).offset().top + offset
	// 	}, 2000);
	// });
	jQuery(".showBlueDots").click(function(){
		$(".greenDot").fadeOut();
		$(".blueDot").fadeIn();
		$(".showBlueDots").addClass('activeState');
		$(".showGreenDots").removeClass('activeState');
		$(".showAllDots").removeClass('activeState');
	});
	jQuery(".showGreenDots").click(function(){
		$(".greenDot").fadeIn();
		$(".blueDot").fadeOut();
		$(".showBlueDots").removeClass('activeState');
		$(".showGreenDots").addClass('activeState');
		$(".showAllDots").removeClass('activeState');
	});
	jQuery(".showAllDots").click(function(){
		$(".greenDot").fadeIn();
		$(".blueDot").fadeIn();
		$(".showBlueDots").removeClass('activeState');
		$(".showGreenDots").removeClass('activeState');
		$(".showAllDots").addClass('activeState');
	});

	jQuery(".alm-btn-wrap").click(function(){
		$("html, body").animate({ scrollTop: $(".newsFeedNav").offset().top }, 500); return false;
	});
	jQuery( ".mobileMenu .accordion-menu .menu-item-2123 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page is-submenu-item is-accordion-submenu-item' role='treeitem'><a href='/about/'>About Overview</a></li>" );
	jQuery( ".mobileMenu .accordion-menu .menu-item-2104 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page is-submenu-item is-accordion-submenu-item' role='treeitem'><a href='/grants/'>Grants Overview</a></li>" );	
	jQuery( ".mobileMenu .accordion-menu .menu-item-2105 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page is-submenu-item is-accordion-submenu-item' role='treeitem'><a href='/loans/'>Loans Overview</a></li>" );	
	jQuery( ".mobileMenu .accordion-menu .menu-item-2109 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page is-submenu-item is-accordion-submenu-item' role='treeitem'><a href='/resources/'>Resources Overview</a></li>" );	


	jQuery( ".top-bar-right .menu .menu-item-2123 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page menu-item-373 is-submenu-item is-dropdown-submenu-item' role='menuitem'><a href='/about/'>About Overview</a></li>" );	
	jQuery( ".top-bar-right .menu .menu-item-2104 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page menu-item-373 is-submenu-item is-dropdown-submenu-item' role='menuitem'><a href='/grants/'>Grants Overview</a></li>" );	
	jQuery( ".top-bar-right .menu .menu-item-2105 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page menu-item-373 is-submenu-item is-dropdown-submenu-item' role='menuitem'><a href='/loans/'>Loans Overview</a></li>" );	
	jQuery( ".top-bar-right .menu .menu-item-2109 .menu" ).prepend( "<li class='menu-item menu-item-type-post_type menu-item-object-page menu-item-373 is-submenu-item is-dropdown-submenu-item' role='menuitem'><a href='/resources/'>Resources Overview</a></li>" );	


	jQuery('.newsMobileSlider').slick({
		dots: false,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
		  {
			breakpoint: 1024,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  infinite: true,
			  dots: true
			}
		  },
		]
	});	
});

// $('.phoneLink').attr('href', functitableWrapon (_, v) {
// 	return v.replace(/\(0\)|\s+/g, '');
// });

// var corrected = $('.footerAddress').attr('href').replace(/ /g, '+');
// $('.footerAddress').attr('href', corrected);

